import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import { DashboardComponentProps } from '../types/DashboardTypes';

const Router: React.FC<DashboardComponentProps> = ({ darkMode, setDarkMode }) => {
  return (
    <Routes>
      <Route element={<PublicRoute darkMode={darkMode}/>}>
        <Route path="/login" element={<Login />} />
      </Route>
      <Route element={<PrivateRoute darkMode={darkMode}/>}>
        <Route path="/dashboard/*" element={<Dashboard darkMode={darkMode} setDarkMode={setDarkMode} />} />
      </Route>
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default Router;